interface Props {
  numerator: number;
  denominator: number;
  color?: string;
  label?: string;
}

export default function FractionBar({
  numerator,
  denominator,
  color = '#2b8bd8',
  label,
}: Props) {
  const parts = Array.from({ length: denominator });
  return (
    <div className="card p-5 space-y-3">
      {label && <div className="font-display text-lg">{label}</div>}
      <div className="flex border-2 border-ink/10 rounded-xl overflow-hidden h-14">
        {parts.map((_, i) => (
          <div
            key={i}
            className="flex-1 border-r last:border-r-0 border-ink/10"
            style={{ backgroundColor: i < numerator ? color : 'transparent' }}
          />
        ))}
      </div>
      <div className="text-center math-display text-2xl">
        {numerator} / {denominator}
      </div>
    </div>
  );
}
